/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
const u = (s) => s != null, f = (s, t, i) => !u(s) || isNaN(s) || s <= t ? t : s >= i ? i : s;
export {
  f as fitIntoBounds,
  u as isPresent
};
